import React, { useEffect, useState } from "react";
import arrowleft from "../assets/images/arrow-left.png";
import attachfile from "../assets/images/attach_file.png";
import Nav from "./Nav";
import DropdownRight from "./DropdownRight";
import Modal from "react-bootstrap/Modal";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import ReactInputMask from "react-input-mask";
import http from "../services/http";
import GetStorage from "../services/Storage";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showToast } from "./ShowToast";
import { ToastContainer } from "react-toastify";
import { SpinnerCircular } from "spinners-react";
import dropdown from "../assets/images/dropdown.png";
import DatePicker from "react-datepicker";
import Loader from "./Loader";

export default function NewTeams() {
  const token = GetStorage.get("xAuthToken");
  const [value, setValues] = useState("0");
  const [url, setUrl] = useState("");
  const [showModal, setShow] = useState(false);
  const dispatch = useDispatch();
  // const [name, setEmail] = useState("");
  const [files, setFile] = useState({});
  const [loading, setLoading] = useState(false);
  const [toggle, setToggle] = useState(true);
  const [filename, setFilename] = useState("");
  const [showPreviewSheetModal, setShowPreviewSheetModal] = useState(false);
  const [formattedData, setformattedData] = useState([]);

  const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);
  const navigate = useNavigate();
  // const location = useLocation();
  // const { email } = location.state;

  const initialValues = {
    name: "",
    coach_name: "",
    coach_email: "",
    confirm_email: "",
    cell_number: "",
    password: "",
    pool_address: "",
    mailing_address: "",
    video_send_mode_via_email_sms: "auto",
    bank_name: "",
    account_number: "",
    routing_number: "",
    price: "",
    lease_start_date: "",
    isSendNotification: true,

  };
  const phoneRegExp = /^[0-9]*$/

  const csvColumns = [
    "TEAM",
    "GROUP",
    "FirstName",
    "LastName",
    "ParentEmail",
    "ParentPhone",
    "AGE",
    "GENDER",
    "ParentFirstName",
    "ParentLastName"
  ];

  const validationSchema = Yup.object({
    name: Yup.string().required("Required"),
    coach_name: Yup.string().required("Required"),
    coach_email: Yup.string().required("Required"),
    confirm_email: Yup.string().oneOf([Yup.ref('coach_email'), null], 'Email and Confirm Email Must be same value.'),
    //cell_number: Yup.string().required("Required"),
    cell_number: Yup.string().required("Required"),
    password: Yup.string().required("Required"),
    pool_address: Yup.string().required("Required"),
    mailing_address: Yup.string().required("Required"),
    bank_name: Yup.string().required("Required"),
    account_number: Yup.string()
      .required("Required")
      .min(10, "Accoun number must be 10 digits."),
    routing_number: Yup.string()
      .required("Required")
      .min(9, "Routing number must be 9 digits."),
    price: Yup.string().required("Required"),
    lease_start_date: Yup.date().required("Lease start date is required").nullable()
    // name: Yup.string().required("Required"),
    // coachname: Yup.string().required("Required"),
  });
  const handleChanges = (event) => {
    const val = event.target.value;
    setValues(val);
  };

  const config = {
    headers: { "content-type": "multipart/form-data" },
  };

  // const handleUpload = (e) => {
  //   const file = e.target.files[0];
  //   console.log("csv file", file);

  //   if (file.type !== "text/csv") {
  //     setError("Invalid file.");
  //     return;
  //   } else {
  //     setError("");
  //   }
  //   http
  //     .post(`api/admin/team/csv?token=${token}`, {
  //       file_type: "text/csv",
  //     })
  //     .then((res) => {
  //       console.log("response", res.data);
  //       const { url, key } = res.data;
  //       console.log(url, key);
  //       setUrl(key);
  //       fetch(url, {
  //         body: file,
  //         method: "PUT",
  //         headers: {
  //           "content-type": file.type,
  //           Accept: "*/*",
  //         },
  //       });
  //     })
  //     .catch((error) => {
  //       console.log("error ", error.response.data.errors);
  //     });
  // };
  let formData = new FormData();

  const handleUpload = (e) => {
    const file = e.target.files[0];
    setFile(file);
    e.target.value = null;
    setFilename(file.name);
    // console.log("file in upload function ", file);
    handleSheetPreviewData(file)
  };

  const handleSheetPreviewData = (file) => {
    setLoading(true)
    let formData = new FormData();
    formData.append("csv", file);
    // formData.append("id", id);
    http
      .post(`api/admin/team/create-team/preview-sheet-data?token=${token}`, formData)
      .then((res) => {
        setShowPreviewSheetModal(true)
        formatDataForTable(res.data.data)
        setLoading(false);

      })
      .catch((error) => {
        //console.log("error ", error);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              showToast("error", error.response.data.errors[key], 8000);
            }
          } else if (error.response.data.message) {
            showToast("error", error.response.data.message, 8000);
          }
        }
        setLoading(false);
      });
  }
  const onSubmits = async (values, { resetForm }) => {
    formData = new FormData(); 
    formData.append("csv", files);
    formData.append("payment_type", value);
    formData.append("video_send_mode_via_email_sms", values.video_send_mode_via_email_sms);
    for (let key in values) {
      if (key !== "video_send_mode_via_email_sms") {
        formData.append(key, values[key]);
      }
    }
    setLoading(true);

    http
      .post(`api/admin/team?token=${token}`, formData)
      .then((res) => {
        console.log(res);
        showToast("success", res.data.message);
        setLoading(false);
        resetForm();

        navigate("/teams");
      })
      .catch((error) => {
        setLoading(false);

        console.log(error);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              showToast("error", error.response.data.errors[key], 8000);
              handleClose();
            }
          } else if (error.response.data.message) {
            showToast("error", error.response.data.message, 8000);
            handleClose();
          }
        }
      });
  };

  const onSubmit = async (values, { resetForm }) => {
    http
      .post(`api/admin/team?token=${token}`, {
        name: values.name,
        coach_name: values.coach_name,
        coach_email: values.coach_email,
        cell_number: values.cell_number,
        pool_address: values.pool_address,
        mailing_address: values.mailing_address,
        bank_name: values.bank_name,
        account_number: values.account_number,
        routing_number: values.routing_number,
        price: values.price,
        payment_type: value,
        csv: url,
      })
      .then((res) => {
        console.log("added new user", res.data);

        // resetForm();
        // navigate(`/advancedSecuritySettings/${values.coach_email}`);
      })
      .catch((error) => {
        console.log("error ", error.response.data.errors);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
            }
          } else if (error.response.data.message) {
          }
        }
      });
  };

  const formatDataForTable = (data) => {
    let finalData = data.map((row) => {
      return csvColumns.map((col, index) => {
        let style = {};
        let errorMessage = ""; // Initialize error message for hover (tooltip)

        // Check if the cell has been modified
        if (row.updated && row.modifiedColumns.includes(col)) {
          style = { ...style, backgroundColor: "yellow" }; // Highlight updated cells in yellow
        }

        // Check if the row has not changed
        if (row.noChange) {
          style = { ...style, backgroundColor: "green",color:"white" }; // Highlight unchanged cells in green
        }

        // Check if there are errors for the field and apply red styling
        if (row.errors[col]) {
          style = {
            ...style,
            // border: "1px solid red", // Apply red border
            backgroundColor: "red", // Text in red color
            color:"white"
          };
          errorMessage = row.errors[col]; // Set the error message for hover (tooltip)
        }

        //change white cell with color green 
        if (!style.backgroundColor) {
          style = { ...style, backgroundColor: 'green', color: 'white' };
        }

        // Return the final object with value, style, and error message
        return { value: row[col], style, errorMessage };
      });
    });

    setformattedData(finalData);
  };

  return (
    <>
      <body>
        <div className="wrapper">
          {loading && <Loader />}
          <Nav
          //  sidebarClass={toggle ? "show" : "hide"}
          />

          <div id="content">
            <header>
              <div className="dashboard_header">
                <div className="left-side d-flex ">
                  <button
                    onClick={() => navigate("/teams")}
                    type="button"
                    className="btn btn-link  "
                  >
                    {" "}
                    <img src={arrowleft} className="img-fluid" />{" "}
                  </button>
                  <h1>New Team</h1>{" "}
                </div>
                <DropdownRight />
              </div>
            </header>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmits}
            >
              {({ values, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                <>
                  <div className="dashbord_content">
                    <div className="dashobord_inner new_team_add">
                      <h5 className="my-3">General Info</h5>
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Name</label>
                              <input
                                name="name"
                                onChange={handleChange("name")}
                                onBlur={handleBlur("name")}
                                value={values.name}
                                className="custom_input form-control"
                                placeholder="Team Name"
                              />
                              <div
                                style={{
                                  color: "red",
                                }}
                              >
                                <ErrorMessage name="name" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Coach Name</label>
                              <input
                                name="coach_name"
                                onChange={handleChange("coach_name")}
                                onBlur={handleBlur("coach_name")}
                                value={values.coach_name}
                                className="custom_input form-control"
                                placeholder="Coach Name"
                              />
                              <div
                                style={{
                                  color: "red",
                                }}
                              >
                                <ErrorMessage name="coach_name" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Coach Email</label>
                              <input
                                type="email"
                                name="coach_email"
                                onChange={handleChange("coach_email")}
                                onBlur={handleBlur("coach_email")}
                                value={values.coach_email}
                                className="custom_input form-control"
                                placeholder="Coach Email"
                              />
                              <div
                                style={{
                                  color: "red",
                                }}
                              >
                                <ErrorMessage name="coach_email" />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Confirm Coach Email</label>
                              <input
                                type="email"
                                name="confirm_email"
                                onChange={handleChange("confirm_email")}
                                onBlur={handleBlur("confirm_email")}
                                value={values.confirm_email}
                                className="custom_input form-control"
                                placeholder="Confirm Email"
                              />
                              <div
                                style={{
                                  color: "red",
                                }}
                              >
                                <ErrorMessage name="confirm_email" />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Cell Number</label>
                              {/* <input
                                name="cell_number"
                                onChange={handleChange("cell_number")}
                                onBlur={handleBlur("cell_number")}
                                value={values.cell_number}
                                className="custom_input form-control"
                                placeholder="Coach Cellphone Number"
                              /> */}
                              <ReactInputMask placeholder="+1 999-999-9999" className="custom_input form-control" id="cell_number"
                                name="cell_number" mask={"+1 999-999-9999"}
                                onBlur={handleBlur("cell_number")}
                                onChange={e => {
                                  let phone = e.currentTarget.value.replace(/\(|\)|\s|-/g, "")
                                  setFieldValue('cell_number', phone)
                                  if (phone.length >= 12 || phone.length >= 10) {
                                    values['cell_number'] = phone;
                                  }
                                }}
                                value={values.cell_number}
                              >
                              </ReactInputMask>
                              <div
                                style={{
                                  color: "red",
                                }}
                              >
                                <ErrorMessage name="cell_number" />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-4 col-sm-6">
                            <div class="fomr-group">
                              <label>Coach Password</label>
                              <input
                                name="password"
                                onChange={handleChange("password")}
                                onBlur={handleBlur("password")}
                                value={values.password}
                                type={"password"}
                                className="custom_input form-control"
                                placeholder="Coach Password"
                              />
                              <div
                                style={{
                                  color: "red",
                                }}
                              >
                                <ErrorMessage name="password" />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Street Address</label>
                              <input
                                name="pool_address"
                                onChange={handleChange("pool_address")}
                                onBlur={handleBlur("pool_address")}
                                value={values.pool_address}
                                className="custom_input form-control"
                                placeholder="Coach Street Address"
                              />
                              <div
                                style={{
                                  color: "red",
                                }}
                              >
                                <ErrorMessage name="pool_address" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Mailing Address</label>
                              <input
                                name="mailing_address"
                                onChange={handleChange("mailing_address")}
                                onBlur={handleBlur("mailing_address")}
                                value={values.mailing_address}
                                className="custom_input form-control"
                                placeholder="City, state, zip"
                              />
                              <div
                                style={{
                                  color: "red",
                                }}
                              >
                                <ErrorMessage name="mailing_address" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Send Email As</label>
                              <div className="custom_radio_group">
                                <label className="radio_container">
                                  Auto
                                  <input
                                    type="radio"
                                    name="video_send_mode_via_email_sms"
                                    value="auto"
                                    checked={values.video_send_mode_via_email_sms === "auto"}
                                    onChange={() => setFieldValue("video_send_mode_via_email_sms", "auto")}
                                  />
                                  <span className="radio_checkmark"></span>
                                </label>
                                <label className="radio_container">
                                  Manual
                                  <input
                                    type="radio"
                                    name="video_send_mode_via_email_sms"
                                    value="manual"
                                    checked={values.video_send_mode_via_email_sms === "manual"}
                                    onChange={() => setFieldValue("video_send_mode_via_email_sms", "manual")}
                                  />
                                  <span className="radio_checkmark"></span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12 col-sm-6">
                            <div className="fomr-group">
                              <label class="check_box">
                                <input
                                  type="checkbox"
                                  name="isSendNotification"
                                  checked={values.isSendNotification}
                                  onChange={(e) => {
                                    setFieldValue("isSendNotification", e.target.checked)
                                  }
                                  }
                                />
                                <span class="checkmark"></span>Allow SMS/Email
                              </label>
                            </div>
                          </div>

                          <div className="col-12">
                            <div
                              className="upload_btn_wrapper_attach"
                              style={{ display: "flex" }}
                            >
                              <div style={{ cursor: 'pointer' }}>
                                <button className="btn">
                                  <img src={attachfile} className="mr-2" />
                                  Upload CSV File
                                </button>
                                <input
                                  type="file"
                                  name="myfile"
                                  onChange={handleUpload}
                                />{" "}
                              </div>
                              <div className="upload_btn_wrapper_attach">
                                <button
                                  type="button"
                                  className="btn ml-2" // Added margin left to space it from the first button
                                  onClick={() => {
                                    // Add logic for previewing the sheet here
                                    setShowPreviewSheetModal(true);
                                  }}
                                >
                                  Preview File
                                </button>
                              </div>
                            </div>
                            {
                              filename &&
                              <h5
                                style={{
                                  alignItems: "center",
                                  display: "flex",
                                  padding: 10,
                                }}
                              >
                                {" "}
                                {filename}
                              </h5>
                            }
                          </div>
                          <div className="col-12">
                            <h5 className="my-3">Bank Details</h5>{" "}
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Bank Name</label>
                              <input
                                name="bank_name"
                                onChange={handleChange("bank_name")}
                                onBlur={handleBlur("bank_name")}
                                value={values.bank_name}
                                className="custom_input form-control"
                                placeholder="Bank Name"
                              />
                              <div
                                style={{
                                  color: "red",
                                }}
                              >
                                <ErrorMessage name="bank_name" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Account Number</label>
                              <input
                                name="account_number"
                                onChange={handleChange("account_number")}
                                onBlur={handleBlur("account_number")}
                                value={values.account_number}
                                className="custom_input form-control"
                                placeholder="Enter account number"
                              />
                              <div
                                style={{
                                  color: "red",
                                }}
                              >
                                <ErrorMessage name="account_number" />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Routing Number</label>
                              <input
                                name="routing_number"
                                onChange={handleChange("routing_number")}
                                onBlur={handleBlur("routing_number")}
                                value={values.routing_number}
                                className="custom_input form-control"
                                placeholder="Enter routing number"
                              />
                              <div
                                style={{
                                  color: "red",
                                }}
                              >
                                <ErrorMessage name="routing_number" />
                              </div>
                            </div>
                          </div>
                          <div className="col-12">
                            <h5 className="my-3">Payment method</h5>{" "}
                          </div>

                          <div className="col-md-4 col-sm-6 Edit_Setting">
                            <div
                              className="form-group icon "
                              style={{ maxWidth: "100%" }}
                            >
                              <label>Payment Type</label>

                              <select
                                value={values.payment_type}
                                onChange={handleChanges}
                                className="form-control custom_input w-100"
                              >
                                <option value="0">Single Pay</option>
                                <option value="1">Monthly subscription</option>
                              </select>
                              <div className="img_icon">
                                {" "}
                                <img src={dropdown} alt="" />{" "}
                              </div>
                            </div>
                          </div>

                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Amount</label>
                              <input
                                type="number"
                                name="price"
                                onChange={handleChange("price")}
                                onBlur={handleBlur("price")}
                                value={values.price}
                                className="custom_input form-control"
                                placeholder="Enter Amount"
                              />
                              <div
                                style={{
                                  color: "red",
                                }}
                              >
                                <ErrorMessage name="name" />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-4 col-sm-6">
                            <div className="form-group lease_date">
                              <label>Lease Start Date</label>
                              <div>

                                <DatePicker
                                  selected={values.lease_start_date}
                                  onChange={(date) => setFieldValue("lease_start_date", date)}
                                  onBlur={handleBlur("lease_start_date")}
                                  className="custom_input form-control"
                                  minDate={new Date()}
                                  placeholderText="Select lease start date"
                                />
                              </div>
                              <div
                                style={{
                                  color: "red",
                                }}
                              >
                                <ErrorMessage name="lease_start_date" />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 d-flex justify-content-end">
                            <div className="btn_wraper d-flex Permissions_text align-item-center mt_40 mb_30">
                              <Link to="/teams">
                                <button
                                  type="button"
                                  className=" them_btn_ouline  "
                                >
                                  Cancel
                                </button>
                              </Link>

                              <button
                                type="button"
                                to="/advancedSecuritySettings"
                                onClick={handleSubmit}
                                className=" them_btn  "
                              >
                                {loading ? (
                                  <SpinnerCircular
                                    style={{ height: "40", marginTop: "7" }}
                                  />
                                ) : (
                                  "  Save"
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </>
              )}
            </Formik>

            <Modal
              //  show={true}
              show={showPreviewSheetModal}
              onHide={() => setShowPreviewSheetModal(false)}
              className="teamInfo-modal"
            >
              <Modal.Header>
                <Modal.Title>Preview File Data</Modal.Title>
                <button type="button" className="close"
                  onClick={() => setShowPreviewSheetModal(false)}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </Modal.Header>
              <Modal.Body style={{ maxHeight: '600px', overflowY: 'auto' }}>
                {formattedData.length === 0 ? (
                  <div style={{ textAlign: "center", padding: "20px" }}>No data available</div>
                ) : (
                  <div>
                    <div style={{ display: 'flex', gap: '15px', marginBottom: '15px' }}>
                      <div
                        style={{
                          backgroundColor: 'green',
                          color: 'white',
                          padding: '5px 10px',
                          borderRadius: '5px',
                          fontWeight: 'bold'
                        }}
                      >
                        No Changes
                      </div>
                      <div
                        style={{
                          backgroundColor: 'red',
                          color: 'white',
                          padding: '5px 10px',
                          borderRadius: '5px',
                          fontWeight: 'bold'
                        }}
                      >
                        Error
                      </div>
                      <div
                        style={{
                          backgroundColor: 'yellow',
                          color: 'black',
                          padding: '5px 10px',
                          borderRadius: '5px',
                          fontWeight: 'bold'
                        }}
                      >
                        Will Be Updated
                      </div>
                    </div>
                    <table border="1" style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead>
                        <tr>
                          <th style={{ padding: "8px",textAlign:'center' }}>ID</th>
                          {csvColumns.map((col) => (
                            <th key={col} style={{ padding: "8px" }}>
                              {col}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {formattedData.map((row, rowIndex) => (
                          <tr key={rowIndex}>
                            <td style={{ padding: "8px", textAlign: "center" }}>
                              {rowIndex + 1}
                            </td>
                            {row.map((cell, colIndex) => (
                              <td
                                key={colIndex}
                                style={{
                                  padding: "8px",
                                  ...cell.style,
                                }}
                                title={cell.errorMessage} // Display error message on hover
                              >
                                {cell.value}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </Modal.Body>
            </Modal>
          </div>
        </div>
        <ToastContainer />
      </body>
    </>
  );
}
